import { render } from "./SnapshotAssignDialog.vue?vue&type=template&id=3650c944"
import script from "./SnapshotAssignDialog.vue?vue&type=script&lang=js"
export * from "./SnapshotAssignDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__